export default __webpack_public_path__ + "static/media/list.930455d9.svg";